import removeAdobeSparkPageBranding from "./WatermarkRemover";

const adobeSparkUrl = "https://express.adobe.com/page/xYA0Ljm9naHTF/";

window.addEventListener('DOMContentLoaded', (event) => {
	removeAdobeSparkPageBranding(adobeSparkUrl);
});
